// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';

export const useWeatherService = () => {
    // properties
    const store = useStore();
    const { state } = store;
    const {apiUrl} = state;
    const axios = useAxios();

    // methods
    const getWeatherLatest = async (courseSchemaId: number, forceUpdate = false): Promise<any> => {
        const weatherDataPerCourse = store.getters.getCurrentWeatherData;
        if(!forceUpdate && weatherDataPerCourse){
            const utcSeconds = weatherDataPerCourse['dt'];
            const lastUpdated = new Date(0);
            lastUpdated.setUTCSeconds(utcSeconds);

            const currentTime   = new Date();
            const milliseconds = (currentTime.getTime() - lastUpdated.getTime());
            if(milliseconds < 30*60*1000){    //30mins
                return weatherDataPerCourse
            }
        }
        const res = await axios.get(`${apiUrl}/weather/${courseSchemaId}`);
        if(res.status == 200){
            const newValue = {}
            newValue[`${courseSchemaId}`] = res.data;
            store.commit(
                'setCurrentWeatherData',
                newValue,
            );
            return res.data;
        }
        return weatherDataPerCourse;
    };
    return {
        getWeatherLatest,
    };
};
